import { useEffect, useState } from "react";
import { Flex, Typography, Tooltip, Button, Tabs, Dropdown } from "antd";
import BackButton from "../../components/CustomButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { entDetailedView } from "../../redux/slices/enterpriseSlice";
import CustomCard from "../../components/CustomCard/CustomCard";
import { TITLE_TXT } from "../../constants/constants";
import {
  capitalizeEntireWord,
  detailedViewDownloadPageHandle,
} from "../../helpers/helpers";
import EnterpriseDetails from "./Components/EnterpriseDetails";
import Documents from "./Components/Documents";
import EnterprisePocs from "./Components/EnterprisePocs.jsx";
import EnterpriseActivityLog from "./Components/EnterpriseActivityLog.jsx";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";

const { Text } = Typography;

const EntDetails = () => {
  const dispatch = useDispatch();
  const { entId, status } = useParams();
  const { entDetailedData } = useSelector((state) => state?.enterprise);
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    dispatch(entDetailedView(entId));
  }, [entId, dispatch]);

  const items = [
    {
      key: "1",
      label: capitalizeEntireWord(TITLE_TXT.ENT_DETS),
      children: (
        <EnterpriseDetails
          entDetailedData={entDetailedData}
          entId={entId}
          status={status}
        />
      ),
    },
    {
      key: "2",
      label: capitalizeEntireWord(TITLE_TXT.DOCS),
      children: <Documents entId={entId} />,
    },
    {
      key: "3",
      label: "POC Library",
      children: (
        <EnterprisePocs
          entId={entId}
          entName={entDetailedData?.entName}
        />
      ),
    },
    {
      key: "4",
      label: "Activity Log",
      children: (
        <EnterpriseActivityLog 
          entId={entId} 
          entName={entDetailedData?.entName}
        />
      ),
    },
  ];

  const handleDownload = () =>
    detailedViewDownloadPageHandle({
      dispatch,
      type: "enterprisePdf",
      id: entId,
    });

  const downloadItems = [
    {
      key: "pdf",
      label: "Download as PDF",
      icon: <FilePdfOutlined />,
    },
    // {
    //     key: "excel",
    //     label: "Download as Excel",
    //     icon: <FileExcelOutlined />,
    // },
  ];

  return (
    <div className="ent-details-container">
      <Flex align="center" style={{ marginBottom: 16 }}>
        <BackButton />

        <Text className="name" style={{ marginLeft: 24 }}>
          {`Viewing Details for ${entDetailedData?.entName || ""}`}
        </Text>
      </Flex>

      <CustomCard>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
          className="ent-details-tabs"
          tabBarExtraContent={
            activeTab === "1" && (
              <Flex align="center" gap={12}>
                <Dropdown
                  menu={{
                    items: downloadItems,
                    onClick: handleDownload,
                  }}
                  placement="bottomRight"
                >
                  <Tooltip title="Download">
                    <Button
                      type="primary"
                      shape="circle"
                      icon={<DownloadOutlined />}
                      disabled={!entDetailedData?.entName}
                    />
                  </Tooltip>
                </Dropdown>
              </Flex>
            )
          }
        />
      </CustomCard>
    </div>
  );
};

export default EntDetails;
